import { Component, OnInit } from "@angular/core";
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { OrderWizardNavigationService } from "../../_service/order-wizard-navigation.service";
import { OrderWizardSaveAndPayComponent } from "../../step-06/summary/save-and-pay/order-wizard-save-and-pay.component";
import { OrderWizardService } from "../../_service/order-wizard.service";

@Component({
    selector: 'order-wizard-footer',
    templateUrl: './order-wizard-footer.component.html',
    styleUrls: ['./order-wizard-footer.component.scss'],
    imports: [CommonModule, ReactiveFormsModule, TranslateModule,OrderWizardSaveAndPayComponent]
})
export class OrderWizardFooterComponent implements OnInit {
    form: FormGroup | null = null;

    constructor(
        public _orderWizardService: OrderWizardService,
        public _orderWizardNavigationService: OrderWizardNavigationService
    ) {

    }

    ngOnInit(): void {
 
    }

    isNextDisabled(): boolean{
        return this._orderWizardNavigationService.isNextDisabled();
    }


}